module.exports = __webpack_public_path__ + "static/media/cashfree.a89c0f59.webp";